import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertCircle } from "lucide-react";

export default function EmergencyProfile() {
  const { cardId } = useParams();
  const [card, setCard] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/idcards/${cardId}`).then(({ data }) => setCard(data)).catch(() => setError(true));
  }, [cardId]);

  if (error) return <div className="max-w-2xl mx-auto px-6 py-16 text-center"><AlertCircle className="h-10 w-10 text-rose-500 mx-auto" /><h1 className="font-display font-bold text-2xl mt-3">Profile not found</h1></div>;
  if (!card) return <div className="max-w-2xl mx-auto px-6 py-16">Loading...</div>;

  const Row = ({ label, value }) => value ? (
    <div className="py-3 border-b border-pink-100 last:border-0">
      <div className="text-xs uppercase tracking-wider text-pink-600 font-bold">{label}</div>
      <div className="text-slate-900 mt-1 font-semibold whitespace-pre-wrap">{value}</div>
    </div>
  ) : null;

  return (
    <div className="max-w-2xl mx-auto px-6 py-10" data-testid="emergency-profile-page">
      <div className="rounded-3xl bg-gradient-to-br from-pink-100 via-purple-50 to-blue-100 p-1 shadow-xl">
        <div className="bg-white rounded-[1.4rem] p-6">
          <div className="rainbow-strip h-1.5 rounded-full mb-5" />
          <div className="text-center">
            <div className="text-xs font-bold text-pink-600 tracking-widest">ZI ZI'S WORLD</div>
            <h1 className="font-display text-2xl font-bold text-slate-900 mt-1">Autism Emergency Profile</h1>
          </div>
          <div className="grid grid-cols-3 gap-4 items-start mt-6">
            {card.photo_data_url ? (
              <img src={card.photo_data_url} alt={card.child_name} className="rounded-2xl aspect-[3/4] object-cover ring-2 ring-pink-200" />
            ) : (
              <div className="rounded-2xl aspect-[3/4] bg-pink-100 grid place-items-center text-pink-500 text-xs">No Photo</div>
            )}
            <div className="col-span-2 space-y-0">
              <Row label="Name" value={card.child_name} />
              <Row label="Date of Birth" value={card.date_of_birth} />
              <Row label="Diagnosis" value={card.diagnosis} />
            </div>
          </div>
          <div className="mt-4">
            <Row label="Emergency Contact" value={card.emergency_contact} />
            <Row label="Phone Number" value={card.phone_number} />
            <Row label="Communication Needs" value={card.communication_needs} />
            <Row label="Allergies" value={card.allergies} />
            <Row label="Notes / Special Instructions" value={card.notes} />
          </div>
          <div className="mt-6 bg-pink-50 rounded-2xl p-4 text-center">
            <p className="text-sm text-pink-700 font-semibold">In an emergency, please be patient, lower your voice, reduce noise, and contact the family above.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
